import { render } from "./SubjectHome.vue?vue&type=template&id=cf74d0be"
const script = {}

import exportComponent from "/var/www/html/pip-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__